const isoDatePattern = /^(\d{4})-(\d{1,2})-(\d{1,2})$/;

export function parseEventDate(value) {
  if (!value || typeof value !== 'string') return null;

  const isoMatch = value.match(isoDatePattern);
  if (isoMatch) {
    const [, year, month, day] = isoMatch;
    const date = new Date(Number(year), Number(month) - 1, Number(day));
    return date.getFullYear() === Number(year) &&
      date.getMonth() === Number(month) - 1 &&
      date.getDate() === Number(day)
      ? date
      : null;
  }

  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime())
    ? null
    : new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate());
}

export function formatEventDate(value) {
  const date = parseEventDate(value);
  if (!date) return value || '—';

  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const year = String(date.getFullYear()).slice(-2);
  return `${month}-${day}-${year}`;
}

export function daysUntilEvent(value, today = new Date()) {
  const date = parseEventDate(value);
  if (!date) return null;

  const todayLocal = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate()
  );

  return Math.round((date.getTime() - todayLocal.getTime()) / 86400000);
}

export function eventTimestamp(event) {
  return parseEventDate(event?.date)?.getTime() ?? Number.MAX_SAFE_INTEGER;
}

export function paymentStatus(event) {
  const raw = String(event?.wooStatus || '').toLowerCase();

  if (raw.includes('completed') || raw.includes('event done')) {
    return { label: 'Event Completed', tone: 'completed' };
  }
  if (raw.includes('paid') || raw.includes('full')) {
    return { label: 'Paid in Full', tone: 'paid' };
  }
  if (raw.includes('balance')) {
    return { label: 'Balance Due', tone: 'balance' };
  }
  if (raw.includes('deposit')) {
    return { label: 'Deposit Due', tone: 'deposit' };
  }
  if (raw) {
    return { label: event.wooStatus, tone: 'balance' };
  }

  return null;
}